import { z } from 'zod';

import { BaseLoanEvent } from './BaseLoanEvent';

export const UpdateAdvanceInterestEvent = BaseLoanEvent.extend({
  type: z.literal('updateAdvanceInterest'),
});
export type UpdateAdvanceInterestEvent = z.infer<typeof UpdateAdvanceInterestEvent>;
